var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center text-left vaillantCont mb-5"
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-5  center" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Indietro")]
                )
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular  h0 widthFull" }, [
        _c("b", [_vm._v(" Superbonus 110% ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h5", [
        _vm._v(
          "Se vuoi gestire una pratica di Cessione del credito per il Superbonus 110% questi sono il documenti necessari\n          "
        ),
        _c("br"),
        _vm._v(
          "( seleziona l'elenco in base al tipo di unita immobiliare oggetto dell'intervento )"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs mt-5",
          attrs: { id: "myTab", role: "tablist" }
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link active black",
                attrs: {
                  id: "home-tab",
                  "data-toggle": "tab",
                  href: "#home",
                  role: "tab",
                  "aria-controls": "home",
                  "aria-selected": "true"
                }
              },
              [_vm._v("Unità Singola")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link black",
                attrs: {
                  id: "profile-tab",
                  "data-toggle": "tab",
                  href: "#profile",
                  role: "tab",
                  "aria-controls": "profile",
                  "aria-selected": "false"
                }
              },
              [_vm._v("Condominio")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tab-content", attrs: { id: "myTabContent" } }, [
        _c(
          "div",
          {
            staticClass: "tab-pane fade show active center",
            attrs: {
              id: "home",
              role: "tabpanel",
              "aria-labelledby": "home-tab"
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("img", {
                  staticClass: "img-fluid widthFull mt-4",
                  attrs: { src: require("../../assets/images/doc_singola.jpg") }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            attrs: {
              id: "profile",
              role: "tabpanel",
              "aria-labelledby": "profile-tab"
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("img", {
                  staticClass: "img-fluid widthFull mt-4",
                  attrs: {
                    src: require("../../assets/images/doc_condominio.jpg")
                  }
                })
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-5 mt-5 center" }, [
      _c("h5", [
        _vm._v(
          "Per procedere con la gestione della pratica contatta il supporto clienti al numero 02 9475 6677\n          "
        ),
        _c("br"),
        _vm._v(" oppure invia una mail a "),
        _c(
          "a",
          {
            staticClass: "link yellow",
            attrs: { href: "mailto:info@chebonus.it" }
          },
          [_vm._v("info@chebonus.it")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b0b1917", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0b1917","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superbonus/index.vue
// module id = null
// module chunks = 